import styled from 'styled-components'
import { Collapse, Table, Radio } from 'antd'

const { Panel } = Collapse

export const AddDiv = styled.div`
  padding: 0 5%;

  @media (min-width: 320px) and (orientation: portrait) {
    padding: 0 5px;
  }

  @media (min-width: 375px) and (max-height: 667px) and (orientation: portrait) {
    padding: 0 5px;
  }

  @media (min-width: 414px) and (max-height: 736px) and (orientation: portrait) {
    padding: 0 5px;
  }

  @media (min-width: 375px) and (max-width: 812px) and (orientation: portrait) {
    padding: 0 5px;
  }

  @media (min-width: 320px) and (orientation: portrait) {
    padding: 0 5px;
  }
`

export const ListDiv = styled.div`
  padding: 1rem 5%;

  @media (min-width: 320px) and (orientation: portrait) {
    padding: 1rem 0;
  }

  @media (min-width: 375px) and (max-height: 667px) and (orientation: portrait) {
    padding: 1rem 0;
  }

  @media (min-width: 414px) and (max-height: 736px) and (orientation: portrait) {
    padding: 1rem 0;
  }

  @media (min-width: 375px) and (max-width: 812px) and (orientation: portrait) {
    padding: 1rem 0;
  }

  @media (min-width: 320px) and (orientation: portrait) {
    padding: 1rem 0;
  }
`

export const TableEx = styled(Table)`
  .ant-table-thead > tr > .ant-table-cell {
    ${(props) => props.id === 1 && `background-color: #fff7e7;`}
    ${(props) => props.id === 2 && `background-color: #fffde5;`}
    ${(props) => props.id === 3 && `background-color: #f1e9f4;`}
    ${(props) => props.id === 4 && `background-color: #e7f7fd;`}
    ${(props) => props.id === 5 && `background-color: #e5f6f5;`}
    ${(props) => props.id === 6 && `background-color: #fbe8ea;`}
    ${(props) => props.id === 7 && `background-color: #f3f9eb;`}
  }

  .ant-table-tbody > tr > .ant-table-cell {
    ${(props) => props.id === 1 && `background-color: #fff7e7;`}
    ${(props) => props.id === 2 && `background-color: #fffde5;`}
    ${(props) => props.id === 3 && `background-color: #f1e9f4;`}
    ${(props) => props.id === 4 && `background-color: #e7f7fd;`}
    ${(props) => props.id === 5 && `background-color: #e5f6f5;`}
    ${(props) => props.id === 6 && `background-color: #fbe8ea;`}
    ${(props) => props.id === 7 && `background-color: #f3f9eb;`}
  }
`

export const CollapseEx = styled(Collapse)`
  .ant-collapse-content > .ant-collapse-content-box {
    padding: 0;
  }
`

export const PanelEx = styled(Panel)`
  ${(props) => props.id === 1 && `background-color: #fcaf17;`}
  ${(props) => props.id === 2 && `background-color: #f9ec00;`}
  ${(props) => props.id === 3 && `background-color: #782b90;`}
  ${(props) => props.id === 4 && `background-color: #14b1e7;`}
  ${(props) => props.id === 5 && `background-color: #00a79e;`}
  ${(props) => props.id === 6 && `background-color: #da2032;`}
  ${(props) => props.id === 7 && `background-color: #8dc63f;`}
  
  ${(props) =>
    props.id === 1 &&
    `
    .ant-collapse-content-box {
      background-color: #fff7e7;
    }
  `}
  
  ${(props) =>
    props.id === 2 &&
    `
    .ant-collapse-content-box {
      background-color: #fffde5;
    }
  `}
  
  ${(props) =>
    props.id === 3 &&
    `
    .ant-collapse-content-box {
      background-color: #f1e9f4;
    }
  `}
  
  ${(props) =>
    props.id === 4 &&
    `
    .ant-collapse-content-box {
      background-color: #e7f7fd;
    }
  `}
  
  ${(props) =>
    props.id === 5 &&
    `
    .ant-collapse-content-box {
      background-color: #e5f6f5;
    }
  `}
  
  ${(props) =>
    props.id === 6 &&
    `
    .ant-collapse-content-box {
      background-color: #fbe8ea;
    }
  `}
  
  ${(props) =>
    props.id === 7 &&
    `
    .ant-collapse-content-box {
      background-color: #f3f9eb;
    }
  `}
`

export const RadioEx = styled(Radio)`
  .ant-radio-group-solid
    .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    ${(props) =>
      props.color &&
      `
      background-color: ${props.color} !important;
      border-color: ${props.color} !important;
    `}
  }
`

export const Text = styled.span`
  color: #6ebf4b;
  ${(props) => props.size && `font-size: ${props.size}px`}
`



// WEBPACK FOOTER //
// ./src/pages/AccountProduct/index.style.js